const addErrorClassName = (errors, touched, name) => {
  return !!errors[name] && touched[name] ? 'is-invalid' : '';
};

export default addErrorClassName;
